import { Link } from "react-router";
import { ChevronRight, Package } from "lucide-react";
import type { ProductType } from "../../../api/catalogue";
import { Icon } from "../../ui";
import { SectionHeading } from "./SectionHeading";

/** Shop by department (desktop kit CategoryTiles): each product type, with how many items it holds. */
export function DepartmentTiles({ types }: { types: ProductType[] }) {
  return (
    <section>
      <SectionHeading
        title="Shop by department"
        action={
          <Link to="/product-types" className="inline-flex items-center gap-1 border-b-0 type-label">
            All supplies <Icon icon={ChevronRight} size={16} />
          </Link>
        }
      />
      <ul className="m-0 grid list-none grid-cols-2 gap-4 p-0 sm:grid-cols-3 lg:grid-cols-6 lg:gap-6">
        {types.map((type) => (
          <li key={type.id}>
            <Link
              to={`/product-types/${type.id}`}
              className="flex h-full flex-col overflow-hidden rounded-lg border border-border-subtle bg-surface-card text-inherit shadow-sm hover:border-green-300 hover:shadow-md"
            >
              <span className="flex aspect-[2/1] items-center justify-center sm:aspect-[4/3] border-b border-border-subtle bg-white text-steel-400">
                <Icon icon={Package} size={30} />
              </span>
              <span className="px-4 pt-3 pb-4">
                <span className="block type-h4 [font-size:var(--text-sm)] text-text-strong">{type.name}</span>
                <span className="mt-0.5 block type-small text-text-muted">
                  {type.listing_count} {type.listing_count === 1 ? "item" : "items"}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
